import { useState } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import AvatarUploader from '../../../../../UI/AvatarUploader'

import http from '../../../../../shared/http'
import { TApi } from '../../../../../shared/const'
import { updateProfile } from '../../../../../redux/ducks/user'
import { useAvatarUrl } from '../../../../../shared/useAvatarUrls'

import styles from '../style.module.scss'

/**
 * Profilbild der Verwaltung.
 *
 * Die einzige Rolle, die bis 23.08.2026 keines hatte — obwohl ihr Name in den
 * Kommentaren einer Anforderung, im Verlauf einer Junior Company und in der
 * Administratoren-Übersicht genauso auftaucht wie jeder andere. Dort standen
 * bisher Initialen, während neben Schüler:innen und Lehrkräften ein Gesicht war.
 */
function AvatarPhoto(props) {
	const { t } = useTranslation()
	const [laedt, setLaedt] = useState(false)
	const avatarSrc = useAvatarUrl(props.avatarHashName)

	const handleSelect = file => {
		const form = new FormData()
		form.append('avatar', file)

		setLaedt(true)
		http.put(TApi.ADMIN_AVATAR, form)
			.then(({ data }) => {
				props.updateProfile({ ...data })
				toast.success(t('Avatar successfully updated'))
			})
			.finally(() => setLaedt(false))
	}

	const handleClean = () => {
		if (!props.avatarHashName) return

		setLaedt(true)
		http.delete(TApi.ADMIN_AVATAR)
			.then(() => {
				toast.success(t('Avatar successfully deleted'))
				props.updateProfile({ avatarHashName: '' })
			})
			.finally(() => setLaedt(false))
	}

	return (
		<div className={styles.section}>
			<h1 className={styles.sectionTitle}>{t('Avatar photo')}</h1>
			<div className={styles.sectionContent}>
				<AvatarUploader
					src={avatarSrc}
					name={props.displayName}
					className={styles.avatarUploader}
					onSelect={handleSelect}
					onClean={handleClean}
					disabled={laedt}
				/>
			</div>
		</div>
	)
}

const mapStateToProps = state => ({
	avatarHashName: state.user.profile.avatarHashName,
	displayName: [state.user.profile.firstName, state.user.profile.lastName].filter(Boolean).join(' ')
})

const mapDispatchToProps = dispatch => ({
	updateProfile: data => dispatch(updateProfile(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(AvatarPhoto)
